import styled from "styled-components";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { theme } from "styles/mui-config";

export const StyledAccordionDetail = styled(AccordionDetails)`
  color: ${theme.palette.secondary.dark};
  font-size: 14px !important;
  padding: 0 40px;
`;
export const StyledAccordionSummary = styled(AccordionSummary)`
  font-size: 16px !important;
  padding: 0 18px !important;
  & div:last-child {
    background-color: ${theme.palette.shadow.main};
    border-radius: 50%;
    width: 23px;
    height: 23px;
    color: white;
    &.Mui-expanded {
      background-color: ${theme.palette.primary.main};
      color: white;
    }
  }
`;
export const StyledAccordion = styled(Accordion)`
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 10px !important;
  &.Mui-expanded {
    border: 1px solid ${theme.palette.primary.dark};
  }
`;
export const StyledContainer = styled(Grid)`
  background-color: white;
  border-radius: 10px !important;
  box-shadow: 0 !important;
  height: max-content;
`;
export const StyledTitle = styled(Typography)`
  position: relative;
  font-size: 20px !important;
  color: ${theme.palette.primary.dark};
  font-weight: bolder !important;
  top: 0px;
  text-align: center;
  padding-top: 20px;

  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;
